module.exports = __webpack_public_path__ + "img/72.7.Chla.e21e1417.png";